import { Translation } from "../model/Language.js";
import { BaseElement, BaseElementOptions } from "./BaseElement.js";
import { Menu } from "./Menu.js";
import { ModalItem, ModalItemOptions } from "./ModalItem.js";
import { Toolbar } from "./Toolbar.js";

export interface ModalOptions extends BaseElementOptions {
    element?: HTMLElement;
    direction?: "left" | "right";
    uid?: string;
    supportHistory?: boolean;
}



export interface ModalShowOptions {
    initiator?: HTMLElement;
    fromHistory?: boolean;
}

export interface ModalHideOptions {
    fromHistory?: boolean;
}

export class Modal extends BaseElement<HTMLElement> {

    private static _uid: number = 0;

    private _uid: string;
    private _session: number = Math.random();
    private _supportHistory: boolean;

    protected _initiator: HTMLElement = null;
    protected _toolbar: Toolbar;
    protected _menu: Menu;
    protected _content: HTMLDivElement;
    protected _header: HTMLDivElement;
    protected _body: HTMLDivElement;
    protected _background: HTMLDivElement;

    public create(options: ModalOptions): this {

        options = e5.object.merge({
            direction: "left",
            supportHistory: true
        } as ModalOptions, options);

        this._supportHistory = window.history.pushState === undefined ? false : options.supportHistory;

        if (!options.uid) {
            if (options.element && options.element.id) {
                this._uid = options.element.id;
            } else {
                this._uid = (++Modal._uid) + "";
            }
        } else {
            this._uid = options.uid;
        }

        super.create(options);

        this.setElement(options.element || document.createElement("div"));

        if (!this.element.id) {
            this.element.id = this._uid;
        }

        this.element.classList.add("awi-modal", "awi-modal--" + options.direction, "awi-modal--hidden");
        if (!this.element.hasAttribute("role")) {
            this.element.setAttribute("role", "menu");
        }

        if (!this.element.querySelector(".awi-modal__background")) {
            var background = document.createElement("div");
            background.className = "awi-modal__background awi-modal__close";
            this.element.prepend(background);
        }
        this._background = this.element.querySelector(".awi-modal__background");

        if (!this.element.querySelector(".awi-modal__content")) {
            this._content = document.createElement("div");
            this._content.className = "awi-modal__content";
            this.element.appendChild(this._content);
        }
        this._content = this.element.querySelector(".awi-modal__content");

        if (!this._content.querySelector(".awi-modal__header")) {
            var header = document.createElement("div");
            header.className = "awi-modal__header";
            header.innerHTML = `
                    <div class="awi-modal__header-left"></div>
                    <div class="awi-modal__header-right"></div>`;
            this._content.prepend(header);
        }
        this._header = this.element.querySelector(".awi-modal__header");

        if (!this._content.querySelector(".awi-modal__body")) {
            var body = document.createElement("div");
            body.className = "awi-modal__body";
            this._content.append(body);
        }
        this._body = this.element.querySelector(".awi-modal__body");

        // this._menu = new Menu().create({
        //     container: this._content.querySelector(".awi-modal__header")
        // });

        // this._menu.addButton({
        //     icon: "fal fa-times",
        //     cssClass: "awi-modal__close",
        //     position: "end",
        //     ariaLabel: {
        //         de: "Schließen",
        //         en: "Close"
        //     }
        // });

        // var left = !this.element.classList.contains("awi-modal--right");
        // if (left) {
        //     this._content.style.transform = `translateX(-100%)`;
        // } else {
        //     this._content.style.transform = `translateX(100%)`;
        // }

        if (!this._body.querySelector(".awi-navigation__list")) {
            var list = document.createElement("ul");
            list.className = "awi-navigation__list";
            this._body.appendChild(list);
        }

        this._toolbar = new Toolbar().create({
            container: this._content.querySelector(".awi-modal__header"),
            orientation: "horizontal"
        });

        this._toolbar.add({
            icon: "fal fa-times",
            group: "default",
            cssClass: "awi-modal__close",
            label: {
                de: "Schließen",
                en: "Close"
            }
        });

        e5.event.on(this.element, "click", ".awi-modal__close", (e) => {
            this.hide();
        });

        // window.addEventListener("beforeunload", () => this.hide(), true);
        // window.addEventListener("pagehide", () => this.hide(), true);
        // document.addEventListener("visibilitychange", (e) => {
        //     if (document.visibilityState !== 'visible') {
        //         this.hide();
        //     }
        // }, true);


        e5.event.on(document.body, "click", "a[href]", (e) => {
            this._session = Math.random();
            this.hide();
        });

        if (this._supportHistory) {
            window.addEventListener("popstate", (e) => {
                if (e.state
                    && e.state.action === this._uid
                    && e.state.session === this._session) {
                    if (this._lastShowOptions) {
                        this._lastShowOptions.fromHistory = true;
                        this.show(this._lastShowOptions);
                    } else {
                        this.show({
                            fromHistory: true
                        });
                    }
                    // window.history.back();
                } else if (this.isOpen) {
                    this.hide({
                        fromHistory: true
                    });
                }
            });
        }

        return this;
    }

    private get isOpen(): boolean {
        return !this.element.classList.contains("awi-modal--hidden");
    }

    private _lastShowOptions: ModalShowOptions = null;
    public show(options: ModalShowOptions): void {
        if (this.isOpen) {
            return;
        }

        if (this._lastShowOptions !== options) {
            this._lastShowOptions = e5.object.merge({}, options);
        }

        if (this._supportHistory && !options.fromHistory) {
            window.history.pushState({
                action: this._uid,
                session: this._session
            }, "", "#" + this._uid);
        }

        e5.tabTrap.push({element: this.element});

        this.element.classList.remove("awi-modal--hidden");
        this.element.offsetWidth;

        this._initiator = options.initiator;
        if (this._initiator) {
            this._initiator.setAttribute("aria-expanded", "true");
        } else {
            console.warn("NO INITIATOR GIVEN");
        }

        // setTimeout(() => {
        //     this._tabTrap.focus("first");
        // }, 100);
    }

    public hide(options: ModalHideOptions = {}): void {
        if (!this.isOpen) {
            return;
        }
        // this._tabTrap.active = false;
        e5.tabTrap.pop();
        this.element.classList.add("awi-modal--hidden");

        if (this._supportHistory && !options.fromHistory) {
            window.history.back();
        }

        //Re-focus the button/element that opened the menu.
        if (this._initiator) {
            this._initiator.focus();
            this._initiator.setAttribute("aria-expanded", "false");
            this._initiator = null;
        }
    }

    public addInfo(label: Translation): HTMLDivElement {
        var e = document.createElement("div");
        e.className = "awi-modal__info";
        lang.set(e, label);

        // this._body.appendChild(e);
        this._body.querySelector(".awi-navigation__list").appendChild(e)

        return e;
    }

    protected addItem(options: ModalItemOptions): ModalItem {
        var item = new ModalItem(options);

        this._body.querySelector(".awi-navigation__list").appendChild(item.element);

        return item;
    }
}